'use client';

/**
 * Typeform inline embed — div with {@code data-tf-live={typeformId}}
 * + Typeform's embed script. Inline variant only (popup/slider/side-tab
 * have different UX considerations).
 */
import { EmbedCard, ConfigurationError, ClipboardIcon, useExternalScript } from './_shared';

interface TypeformBlockProps {
  title?: string;
  /** Slug after {@code typeform.com/to/} (6-32 alphanumerics). */
  typeformId: string;
}

const TYPEFORM_RE = /^[A-Za-z0-9]{6,32}$/;

export function TypeformBlock({ typeformId, title }: TypeformBlockProps) {
  useExternalScript(
    TYPEFORM_RE.test(typeformId ?? '') ? 'https://embed.typeform.com/next/embed.js' : null,
  );

  if (!typeformId || !TYPEFORM_RE.test(typeformId)) {
    return (
      <ConfigurationError message="Typeform ID is invalid. Use the slug after /to/ in the form's public URL (typically 8 alphanumeric chars)." />
    );
  }
  return (
    <EmbedCard title={title} accent={<ClipboardIcon />}>
      <div data-tf-live={typeformId} style={{ minHeight: 500, width: '100%' }} />
    </EmbedCard>
  );
}

export type { TypeformBlockProps };
